export default __webpack_public_path__ + "media/images/series-a-news/valor-economico-logo-3f24a97bc3f51b335bab3d391caa7112.png";